import { NoteMessage } from '@/@types/messages/NoteMessage'
import { UpdateOrderServiceMessage } from '@/@types/messages/UpdateOrderServiceMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'
import { ObjectCreatedResponse } from '@/@types/responses/common/ObjectCreatedResponse'
import { UpdateOrderServicesMessage } from '@/@types/messages/UpdateOrderServicesMessage'

export class OrderServiceService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public createOrderServiceNote(orderServiceId: number, noteMessage: NoteMessage): Promise<ObjectCreatedResponse<number>> {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(noteMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-services/${orderServiceId}/notes`, this.miscellaneousService, requestOptions).then(async response => {
      const json = await response.json()
      return new ObjectCreatedResponse<number>(json.id)
    })
  }

  public deleteOrderService(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-services/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateOrderService(orderServiceId: number, updateOrderServiceMessage: UpdateOrderServiceMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateOrderServiceMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-services/${orderServiceId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateOrderServices(updateOrderServicesMessage: UpdateOrderServicesMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateOrderServicesMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-services`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}